import React, { memo } from 'react';
import { Spinner } from 'fabric-spinner/lib/components/Spinner';

const styles = require('./FullScreenLoader.scss');

export const FullScreenLoader = memo(
    (): JSX.Element => (
        <div className={styles.loading}>
            <Spinner />
        </div>
    )
);
